import classNames from 'classnames';
import React from 'react';
import styles from './SEOAnchor.module.css';

export const SEOAnchor = ({ className, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a className={classNames(styles.seoAnchor, className)} {...props} />
);
